import { SocialLinks } from '../utils/Enum'

export default class UrlHelpers {
  static urlWithHttp(url) {
    if (url) {
      if (url.startsWith('http://') && url.startsWith('https://'))
        return url
      else
        return `http://${url}`
    }
  }

  static getSocialLinksMap(urlsStr) {
    const urls = urlsStr.split("\n")
    const socialLinks = Object.values(SocialLinks)
    const linksMap = {}
    let otherLinks = []

    for (let url of urls) {
      let foundMatch = false
      for (let socialLink of socialLinks) {
        if (!url.includes(socialLink.domain)) continue
        
        linksMap[socialLink.key] = url
        foundMatch = true
        break
      }

      if (!foundMatch) otherLinks.push(url)
    }
    if (otherLinks.length) linksMap['others'] = otherLinks.join("\n")
    
    return linksMap
  }
}



// WEBPACK FOOTER //
// ./app/helpers/UrlHelpers.js